// extracted by mini-css-extract-plugin
module.exports = {"main-logo":"Home_main-logo__1wQ9Y","develop-portal":"Home_develop-portal__37RpM","text-center":"Home_text-center__2X2U8"};